<template>
  <div>
    <van-nav-bar :right-text="username" left-arrow left-text="返回" title="采集监管码" @click-left="onClickLeft" @click-right="goIndex()" />
    <van-cell-group>
      <van-field ref="barcode" v-model="barcode" autofocus label="条码" left-icon="photograph" placeholder="请扫描条码" @keyup="onBarcode" />
    </van-cell-group>
    <van-radio-group v-model="radio" direction="horizontal" @change="radioChange">
      <van-row>
        <van-col span="8">
          <van-radio name="1" span="10">小包装</van-radio>
        </van-col>
        <van-col span="8">
          <van-radio name="2" span="10">中包装</van-radio>
        </van-col>
        <van-col span="8">
          <van-radio name="3" span="10">大包装</van-radio>
        </van-col>
      </van-row>
    </van-radio-group>
    <van-field v-model="collectNumber" label="采集数" name="采集数" readonly />
    <a-table
      :dataSource="list"
      :loading="loading"
      :pagination="false"
      :rowKey="(record,index) => record.index"
      :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,type:'radio',columnWidth:'50px'}"
      :customRow="handleCheck"
      bordered
      size="middle">
      <a-table-column title="监管码" dataIndex="barcode.no" align="center">
      </a-table-column>
    </a-table>
    <van-tabbar fixed placeholder>
      <van-tabbar-item>
        <van-row gutter="20">
          <van-col span="0">
            <van-button round block type="info" style="margin: 16px;" native-type="save" :loading="saveLoading"
                        @click="save">保存
            </van-button>

          </van-col>
          <van-col span="0">
            <van-button round block type="info" style="margin: 16px;" native-type="delete" :loading="delLoading"
                        @click="clean">删除
            </van-button>
          </van-col>
        </van-row>
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>


<script>
import debounce from 'lodash/debounce'
import { del, findOne, post } from '@/api/Api'
import { Toast } from 'vant'
import api from '@/api'
import { NavBar } from '../../Common.vue'
import { getSupervisionBarcode, getUser } from '@/pdaView/utils'


export default {
  components: {
    NavBar
  },
  data() {
    return {
      loading: false,
      username: getUser().name,
      selectedRowKeys: [],
      selectedRows: {},
      list: [],
      collectNumber: null,
      barcode: null,
      radio: '1',
      delLoading: false,
      saveLoading: false

    }
  },
  methods: {
    radioChange(i) {
      this.radio = i
      this.search(i)
      console.log(this.radio)
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.handleCheck()
    },
    handleCheck(record, index) {
      return {
        on: {
          click: () => {
            this.selectedRowKeys = [index]
            this.selectedRows = record
          }
        }

      }
    },
    onClickLeft() {
      this.$router.back()

    },
    goIndex() {
      this.$router.push({ name: 'PdaIndex' }, (res) => {
      })
    },
    onBarcode: debounce(function(data, event) {
      if ([13].includes(data.keyCode)) {
        const value = _.trim(data.target.value)
        this.save(value)
      }

    }, 300),
    search(radio) {
      let body = {
        'command.id': this.$route.params.detail.command.id
      }
      findOne('supervisionBarcodeReceiptFactory', body).then(res1 => {
        if (res1.success) {
          let list = getSupervisionBarcode(this.$route.params.detail.command.quantity, res1.result, this.$route.params.detail.pack.innerFactor, this.$route.params.detail.pack.factor)
          if (radio === '1') {
            console.log(list)
            this.list = list.small
            this.ScannedNumber = list.smallScannedNumber
            this.SweptNumber = list.smallSweptNumber
            this.collectNumber = list.smallSweptNumber + '/' + list.smallScannedNumber
          } else if (radio === '2') {
            this.ScannedNumber = list.middleScannedNumber
            this.SweptNumber = list.middleSweptNumber
            this.list = list.middle
            this.collectNumber = list.middleSweptNumber + '/' + list.middleScannedNumber
          }else if (radio==='3'){
            this.ScannedNumber = list.largeScannedNumber
            this.SweptNumber = list.largeSweptNumber
            this.list = list.large
            this.collectNumber = list.largeSweptNumber + '/' + list.largeScannedNumber
          }
        }
      })
    },

    save() {
      let cp = this
      console.log(this.SweptNumber)
      console.log(this.ScannedNumber)
      if (this.SweptNumber >= this.ScannedNumber) {
        this.barcode = null
        Toast('采集数不能大于监管码数')

      } else {
        let body = {}
        let arr = []
        arr.push(this.barcode)
        if (this.radio === '1') {
          body = {
            operationType: 2,
            'id': this.$route.params.detail.command.id,
            smallPack: arr,
            mediumPack: [],
            largePack: []
          }


        } else if (this.radio === '2') {
          body = {
            operationType: 2,
            'id': this.$route.params.detail.command.id,
            smallPack: [],
            mediumPack: arr,
            largePack: []
          }
        } else if (this.radio === '3') {
          body = {
            operationType: 2,
            'id': this.$route.params.detail.command.id,
            smallPack: [],
            mediumPack: [],
            largePack: arr
          }
        }
        this.saveLoading = true
        post(api.supervisingSaveAll, { type: '' }, body).then(res => {
          if (res.success) {
            Toast('保存成功！')
            this.barcode = null
            this.search(this.radio)
          }
        }).finally(() => {
          this.saveLoading = false
        })
      }
    },
    clean() {
      if (!this.selectedRows) {
        Toast('请选择一行数据')
        return
      }
      let data = this.selectedRows
      post(api.supervisingDelete, { type: 'supervisionBarcodeDeleter' }, { no: data.barcode.no }).then(res => {
        console.log(res)
        if (res.success) {
          this.delLoading = true
          Toast('删除成功')
          this.search(this.radio)
        }
      }).finally(() => {
        this.delLoading = false
      })
    }


  },
  created: function() { // 创建生命周期

    this.search('1')
  },
  beforeRouteLeave(to, from, next) {
// 导航离开当前路由的时候被调用，this可以被访问到
//     console.log(this) // 可以访问this
    console.log(to)
    console.log(from)
    console.log('beforeRouteLeave')
    next()
  }


}


</script>